import React from 'react'
import './styles'

import { Link } from 'react-router-dom'

# componennts
import Pager          from '/components/pager/history-pager'
import Spinner        from '/components/spinner'
import List           from '/components/list'
import Filters        from '/components/filters'
import ModalState     from '/components/modal-state'
import Modal          from 'react-bootstrap/lib/Modal'
import flash          from '/lib/flash'

monify = (val)-> new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format parseFloat val or 0

import FaPlus   from 'react-icons/lib/fa/plus'

import {
  withVenues
  withTicketmasterVenues
  withCreateVenue
  withUpdateVenue
} from './queries'

export default \
withVenues \
withTicketmasterVenues \
withCreateVenue \
withUpdateVenue \
class Venues extends React.Component
  constructor: ->
    super arguments...
    @state =
      venue: undefined

  editVenue: (venue)=>
    @setState venue: venue

  updateVenue: (field, value)=>
    @setState venue: {@state.venue..., "#{field}": value}

  saveVenue: =>
    {id, name, address, facility_fee, ticketmaster_id, created_at} = @state.venue or {}
    unless name and address and "#{facility_fee}"
      flash 'Required fields missing'
    if created_at
      @props.updateVenue id, {name, address, facility_fee, ticketmaster_id}
    else
      @props.createVenue {name, address, facility_fee, ticketmaster_id}

  render: ->
    <div className="Venues">
      <header>
        <h1>Venues</h1>
        {@venueModal()}
      </header>
      <section className="content">
        {@filters()}
        {@list()}
        {@pager()}
      </section>
    </div>

  filters: ->
    <Filters>
      <Filters.Search placeholder="Search Venue Name"/>
      <span className="pull-right">
        <Pager meta={@props.venuesPagination} buffer={2}/>
      </span>
    </Filters>

  list: ->
    return <Spinner/> if @props.venuesLoading
    <List>
      {@header()}
      {for venue in @props.venues
        <List.Row key={venue._key}>
          <List.Cell className="id" title={venue.id}>
            {venue.id}
          </List.Cell>
          <List.Cell className="name">
            {venue.name}
          </List.Cell>
          <List.Cell className="address">
            {venue.address}
          </List.Cell>
          <List.Cell className="ticketmaster_id">
            <code>{venue.ticketmaster_id}</code>
          </List.Cell>
          <List.Cell className="facility_fee">
            {monify venue.facility_fee}
          </List.Cell>
          <List.Cell className="actions">
            <button
              className="btn btn-default"
              onClick={@editVenue.bind @, venue}
            >Edit</button>
          </List.Cell>
        </List.Row>
      }
    </List>

  header: ->
    <List.HeaderRow>
      <List.Header className="id">ID</List.Header>
      <List.Header className="name">Name</List.Header>
      <List.Header className="address">Address</List.Header>
      <List.Header className="ticketmaster_id">Ticketmaster ID</List.Header>
      <List.Header className="facility_fee">Facility Fee</List.Header>
      <List.Header className="actions"></List.Header>
    </List.HeaderRow>

  pager: ->
    <div className="text-center">
      <Pager meta={@props.venuesPagination} buffer={4}/>
    </div>

  venueModal: ->
    <ModalState
      open={!!@state.venue}
      render={({open, toggle})=>
        cancel = =>
          @setState venue: null
          toggle()

        save = =>
          {errors} = await @saveVenue()
          if errors?.length
            flash.error errors
          else
            flash.success "Venue saved"
            @setState venue: null
            toggle()
            @props.venuesRefetch()

        [
          <button
            key={'icon'}
            className='btn btn-default VenueModalToggle'
            onClick={toggle}
          >
            <FaPlus/>{' '}New Venue
          </button>

          <Modal
            key={'modal'}
            show={open}
            onHide={cancel}
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {if @state.venue?.persisted then "Edit venue" else "Import a new Venue"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className='clearfix'>
              <div className="VenueModal">
                {if @state.venue
                  @venueForm()
                else
                  <>
                    <Filters.Search label="Search" name="venue_search" placeholder="Search by Venue Name"/>
                    {if term = history?.state?.state?.venue_search
                      if @props.ticketmaster_venuesLoading
                        <Spinner/>
                      else if @props.ticketmaster_venues.length is 0
                        <div className="no-results">
                          No Ticketmaster venues matching <code>{term}</code>
                        </div>
                      else
                        <List>
                          {for venue in @props.ticketmaster_venues
                            <List.Row key={venue._key}>
                              <List.Cell className="name">
                                {venue.name}
                              </List.Cell>
                              <List.Cell className="address">
                                {venue.address}
                              </List.Cell>
                              <List.Cell className="actions">
                                <button
                                  className='btn btn-default'
                                  onClick={@editVenue.bind @, venue}
                                >
                                  {if venue.persisted then 'Edit' else 'Add'}
                                </button>
                              </List.Cell>
                            </List.Row>
                          }
                        </List>
                    }
                  </>
                }
              </div>
            </Modal.Body>
            {if @state.venue
              <Modal.Footer>
                <button className="btn btn-default" onClick={cancel}> Cancel </button>
                <button className="btn btn-primary" onClick={save}> Save </button>
              </Modal.Footer>
            }
          </Modal>
        ]
      }
    />

  venueForm: =>
    {id, name, address, facility_fee, created_at, persisted} = @state.venue
    # editing = !! created_at
    <form>
      <div className="form-group">
        <label className="control-label">Venue Name</label>
        <input
          type='text'
          value={name}
          required
          disabled={persisted}
          className='form-control'
          placeholder='Venue Name'
          onChange={(evt)=> @updateVenue 'name', evt.target.value}
        />
      </div>
      <div className="form-group">
        <label className="control-label">Address</label>
        <textarea
          type='text'
          value={address}
          required
          disabled={persisted}
          className='form-control'
          placeholder='Venue Address'
          onChange={(evt)=> @updateVenue 'address', evt.target.value}
        />
      </div>
      <div className="form-group">
        <label className="control-label">Facility Fee</label>
        <input
          type='number'
          defaultValue={monify facility_fee}
          required
          className='form-control'
          placeholder='Facility Fee'
          min="0.00" max="100.00" step="0.01"
          onChange={(evt)=> @updateVenue 'facility_fee', parseFloat evt.target.value or 0}
        />
      </div>
    </form>

